class SiteHeader extends HTMLElement {
  connectedCallback() {
    this.megamenuItems = this.querySelectorAll('.has-megamenu');
    this.dropdownItems = this.querySelectorAll('.has-dropdown');
    this.hamburger = this.querySelector('.site-header__hamburger');

    this._initMegaMenu();
    this._initDropdowns();
    this._initMobileMenu();
    this._initSearch();
  }

  _initMegaMenu() {
    this.megamenuItems.forEach((item) => {
      let timer;

      item.addEventListener('mouseenter', () => {
        clearTimeout(timer);
        // Close all others first
        this.megamenuItems.forEach(i => i.classList.remove('is-open'));
        this.dropdownItems.forEach(i => i.classList.remove('is-open'));
        item.classList.add('is-open');
        item.querySelector('.site-nav__link')?.setAttribute('aria-expanded', 'true');
      });

      item.addEventListener('mouseleave', () => {
        timer = setTimeout(() => {
          item.classList.remove('is-open');
          item.querySelector('.site-nav__link')?.setAttribute('aria-expanded', 'false');
        }, 150);
      });

      // Keep open when cursor is on the megamenu itself
      const menu = item.querySelector('.megamenu');
      if (menu) {
        menu.addEventListener('mouseenter', () => clearTimeout(timer));
        menu.addEventListener('mouseleave', () => {
          timer = setTimeout(() => {
            item.classList.remove('is-open');
            item.querySelector('.site-nav__link')?.setAttribute('aria-expanded', 'false');
          }, 150);
        });
      }
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        this.megamenuItems.forEach(i => {
          i.classList.remove('is-open');
          i.querySelector('.site-nav__link')?.setAttribute('aria-expanded', 'false');
        });
      }
    });

    // Close on click outside
    document.addEventListener('click', (e) => {
      if (!this.contains(e.target)) {
        this.megamenuItems.forEach(i => i.classList.remove('is-open'));
        this.dropdownItems.forEach(i => i.classList.remove('is-open'));
      }
    });
  }

  _initDropdowns() {
    this.dropdownItems.forEach((item) => {
      let timer;

      item.addEventListener('mouseenter', () => {
        clearTimeout(timer);
        this.megamenuItems.forEach(i => i.classList.remove('is-open'));
        this.dropdownItems.forEach(i => i.classList.remove('is-open'));
        item.classList.add('is-open');
      });

      item.addEventListener('mouseleave', () => {
        timer = setTimeout(() => item.classList.remove('is-open'), 150);
      });

      const dropdown = item.querySelector('.nav-dropdown');
      if (dropdown) {
        dropdown.addEventListener('mouseenter', () => clearTimeout(timer));
        dropdown.addEventListener('mouseleave', () => {
          timer = setTimeout(() => item.classList.remove('is-open'), 150);
        });
      }
    });
  }

  _initMobileMenu() {
    if (!this.hamburger) return;

    const drawer = this.querySelector('#site-nav-mobile');
    if (!drawer) return;

    const overlay = drawer.querySelector('.mobile-drawer__overlay');
    const closeBtn = drawer.querySelector('.mobile-drawer__close');
    const l1Panel = drawer.querySelector('.mobile-drawer__l1');

    const openDrawer = () => {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      this.hamburger.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    };

    const closeDrawer = () => {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      this.hamburger.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      setTimeout(() => {
        l1Panel?.classList.remove('is-drilled');
        drawer.querySelectorAll('.mobile-drawer__l2').forEach(p => p.classList.remove('is-active'));
      }, 350);
    };

    this.hamburger.addEventListener('click', openDrawer);
    closeBtn?.addEventListener('click', closeDrawer);
    overlay?.addEventListener('click', closeDrawer);

    drawer.querySelectorAll('.js-drill-down').forEach(btn => {
      btn.addEventListener('click', () => {
        const target = drawer.querySelector(`.mobile-drawer__l2[data-panel="${btn.dataset.panel}"]`);
        if (!target) return;
        l1Panel?.classList.add('is-drilled');
        target.classList.add('is-active');
      });
    });

    drawer.querySelectorAll('.js-drill-back').forEach(btn => {
      btn.addEventListener('click', () => {
        l1Panel?.classList.remove('is-drilled');
        drawer.querySelectorAll('.mobile-drawer__l2').forEach(p => p.classList.remove('is-active'));
      });
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
    });
  }

  _initSearch() {
    this.querySelectorAll('.js-search-toggle').forEach(btn => {
      btn.addEventListener('click', () => { window.location.href = '/search'; });
    });
  }
}

if (!customElements.get('site-header')) {
  customElements.define('site-header', SiteHeader);
}
